module.exports = __webpack_public_path__ + "img/database.52a7dac3.png";